import { useEffect, useState } from 'react';
import api from '../utils/functions/api';

// รหัสนำหน้าเลขโครงการ (JS, JSID ฯลฯ) ที่ตั้งไว้ใน Information.project_number_prefixes
// (หน้า /management/project-prefixes) — ค่าตั้งต้นเมื่อโหลดไม่ได้/ยังไม่เคยตั้ง = ค่าที่เคย hardcode ไว้
export const DEFAULT_PROJECT_NUMBER_PREFIXES = ['JS', 'JSID'];

// cache ระดับ module: ฟอร์มสร้างโครงการเปิดบ่อย ไม่ต้องยิง /information ทุกครั้งที่เปิด
let cached = null;
let inflight = null;

export const setProjectNumberPrefixesCache = (list) => {
  cached = list;
};

const load = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api
      .get(`${process.env.REACT_APP_API_URL}/information/`)
      .then((res) => {
        const list = res.data?.project_number_prefixes;
        cached = Array.isArray(list) && list.length ? list : DEFAULT_PROJECT_NUMBER_PREFIXES;
        return cached;
      })
      .catch(() => DEFAULT_PROJECT_NUMBER_PREFIXES)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

// loaded = โหลดรายการจริงจาก server เสร็จแล้ว (หรือมี cache อยู่แล้ว) — ใช้รอก่อนตั้งค่าเริ่มต้นของตัวกรอง
// ไม่งั้นช่วงแรกจะได้ค่า hardcode (DEFAULT_PROJECT_NUMBER_PREFIXES) ไปก่อนแล้วค่อยเปลี่ยนตามทีหลัง
export function useProjectNumberPrefixesState() {
  const [state, setState] = useState({
    prefixes: cached || DEFAULT_PROJECT_NUMBER_PREFIXES,
    loaded: Boolean(cached),
  });
  useEffect(() => {
    let alive = true;
    load().then((list) => alive && setState({ prefixes: list, loaded: true }));
    return () => {
      alive = false;
    };
  }, []);
  return state;
}

export default function useProjectNumberPrefixes() {
  return useProjectNumberPrefixesState().prefixes;
}
